module.exports = __webpack_public_path__ + "static/media/0143_Medium.e7570ba1.jpg";